import React, { useState } from 'react'
import { Icons } from '@pankod/refine-antd'
import { useRouter } from 'next/router'

import { DrawerEditGrade } from '@resources/lms-management/program/program-setup/blocks/DrawerEditGrade'
import { Highlighter } from '../../utils'

import type {
  TConfigurationSection,
  TConfigurationSectionContext,
} from '../types'

export const useGradingConfiguration = ({
  program,
  programId,
  runAndClose,
  search,
}: TConfigurationSectionContext): TConfigurationSection => {
  const router = useRouter()
  const [editGradeShow, setEditGradeShow] = useState(false)

  return {
    menuItems: [
      {
        type: 'group',
        label: <Highlighter search={search} text="Nilai (Grading)" />,
        key: 'Nilai (Grading)',
        children: [
          {
            icon: <Icons.ProjectOutlined />,
            label: <Highlighter search={search} text="Pengaturan Nilai" />,
            key: 'Pengaturan Nilai',
            onClick: () => runAndClose(() => setEditGradeShow(true)),
          },
          {
            icon: <Icons.EyeOutlined />,
            label: <Highlighter search={search} text="Lihat Laporan Nilai" />,
            key: 'Lihat Laporan Nilai',
            onClick: () =>
              runAndClose(() =>
                router.push(`/grade-report?programId=${programId}`),
              ),
          },
        ],
      },
    ],
    overlays: (
      <DrawerEditGrade
        onDrawerClose={() => setEditGradeShow(false)}
        onSubmitted={() => setEditGradeShow(false)}
        open={editGradeShow}
        programName={program?.name}
        selectedId={Number(programId)}
      />
    ),
  }
}
